import { gql } from "@apollo/client";

// Delete-modal context: leaf detection (childrenNodeCount), IoT-detach
// detection for assets (assetLocation.iotConnection) and for systems
// (system.systemType + system.iotConnection — see resolveDeleteIotDetach),
// and client tree root (pathNodes[0]) for same-client picker scoping.
export const DeleteInstalledBaseNodeContext = gql`
    query DeleteInstalledBaseNodeContext ($id: ID!) {
        installedBaseNode (id: $id) {
            id
            childrenNodeCount
            nodeType {
                id
                key
            }
            system {
                id
                systemType
                iotConnection {
                    id
                }
            }
            assetLocation {
                id
                iotConnection {
                    id
                }
            }
            pathNodes {
                id
            }
        }
    }
`;
